import {createEntityAdapter, EntityAdapter} from '@ngrx/entity';
import {createReducer, on} from '@ngrx/store';
import {IDocumentTypesDto} from 'app/main/pages/documents/dto/document-listing.dto';
import {HttpActionState} from 'app/main/pages/users/userslisting/store/users-listing.reducers';
import {UserTimezone} from '../../../signing-pages/signing-page/signing-page.dto';
import {ActivityLogs} from '../../../signing-pages/signing-sidebar/activity-logs/activity-logs-dto';
import * as sharedStoreActions from './shared-store.action';
import {ShareStoreDTO} from './shared-store.dto';


export const documentsTypeAdapter: EntityAdapter<IDocumentTypesDto> = createEntityAdapter<IDocumentTypesDto>({
    selectId: model => model.id,
});


const initialState : ShareStoreDTO = {
    activities: [],
    activitiesRequest: HttpActionState.Init,
    activitiesLoader: false,
    sendInternalMessagesRequest: HttpActionState.Init,
    sendInternalChatFormLoader: false,
    users: [],
    usersRequest: HttpActionState.Init,
    updateActivityStatusRequest: HttpActionState.Init,
    documentTypes: documentsTypeAdapter.getInitialState(),
    documentTypesRequestState: HttpActionState.Init,
    isDocumentTypesLoading: false,
    user_timezone: {} as UserTimezone
}


export const sharedStoreReducer = createReducer(
    initialState,
    
    on(sharedStoreActions.fetchRecipientActivities, (state) => ({
        ...state,
        activitiesRequest: HttpActionState.Busy,
        activitiesLoader: true,
    })),

    on(sharedStoreActions.fetchRecipientActivitiesSuccess, (state, {activities}) => ({
        ...state,
        activitiesRequest: HttpActionState.Done,
        activities: activities,
        activitiesLoader: false
    })),
    
    on(sharedStoreActions.fetchRecipientActivitiesFailure, (state) => ({
        ...state,
        activitiesRequest: HttpActionState.Failed,
        activities: [],
        activitiesLoader: false
    })),


    on(sharedStoreActions.fetchDocumentActivities, (state) => ({
        ...state,
        activitiesRequest: HttpActionState.Busy,
        activitiesLoader: true,
    })),

    on(sharedStoreActions.fetchDocumentActivitiesSuccess, (state, {activities}) => ({
        ...state,
        activitiesRequest: HttpActionState.Done,
        activities: activities,
        activitiesLoader: false
    })),
    
    on(sharedStoreActions.fetchDocumentActivitiesFailure, (state) => ({
        ...state,
        activitiesRequest: HttpActionState.Failed,
        activities: [],
        activitiesLoader: false
    })),


    on(sharedStoreActions.updateMessages, (state, {message}) => ({
        ...state,
        activities: updateMessages(state.activities, message)
    })),


    on(sharedStoreActions.sendInternalMessage, (state) => ({
        ...state,
        sendInternalMessagesRequest: HttpActionState.Busy,
        sendInternalChatFormLoader: true,
    })),
   
    on(sharedStoreActions.sendInternalMessageSuccess, (state, {message}) => ({
        ...state,
        sendInternalMessagesRequest: HttpActionState.Done,
        sendInternalChatFormLoader: false,
        activities: [...state.activities, message],
    })),
   
    on(sharedStoreActions.sendInternalMessageFailure, (state) => ({
        ...state,
        sendInternalMessagesRequest: HttpActionState.Failed,
        sendInternalChatFormLoader: false,
    })),


    on(sharedStoreActions.fetchSubUsers, (state) => ({
        ...state,
        usersRequest: HttpActionState.Busy
    })),


    on(sharedStoreActions.fetchSubUsersSuccess, (state, {users}) => ({
        ...state,
        users: users,
        usersRequest: HttpActionState.Done
    })),

    on(sharedStoreActions.fetchSubUsersFailure, (state) => ({
        ...state,
        usersRequest: HttpActionState.Failed
    })),


    on(sharedStoreActions.updateRecipientActivityStatus, (state) => ({
        ...state,
        updateActivityStatusRequest: HttpActionState.Busy
    })),
    
    on(sharedStoreActions.updateRecipientActivityStatusSuccess, (state) => ({
        ...state,
        activities: updateActivitiesStatus(state.activities),
        updateActivityStatusRequest: HttpActionState.Done
    })),
    
    on(sharedStoreActions.updateRecipientActivityStatusFailure, (state) => ({
        ...state,
        updateActivityStatusRequest: HttpActionState.Failed
    })),

    on(sharedStoreActions.updateDocumentActivityStatus, (state) => ({
        ...state,
        updateActivityStatusRequest: HttpActionState.Busy
    })),
    
    on(sharedStoreActions.updateDocumentActivityStatusSuccess, (state) => ({
        ...state,
        activities: updateActivitiesStatus(state.activities),
        updateActivityStatusRequest: HttpActionState.Done
    })),
    
    on(sharedStoreActions.updateDocumentActivityStatusFailure, (state) => ({
        ...state,
        updateActivityStatusRequest: HttpActionState.Failed
    })),


    on(sharedStoreActions.fetchDocumentTypes, (state) => ({
        ...state,
        documentTypesRequestState: HttpActionState.Busy,
        isDocumentTypesLoading: true
    })),

    on(sharedStoreActions.fetchDocumentTypesSuccess, (state, {documentTypes}) => ({
        ...state,
        documentTypesRequestState: HttpActionState.Done,
        isDocumentTypesLoading: false,
        documentTypes: documentsTypeAdapter.setAll(documentTypes, state.documentTypes)
    })),
    
    on(sharedStoreActions.updateDocumentTypesList,(state, {documentTypes} )=>({
        ...state,
        documentTypes:documentsTypeAdapter.upsertMany(documentTypes, state.documentTypes)
    })),
    
    on(sharedStoreActions.fetchDocumentTypesFailure, (state) => ({
        ...state,
        documentTypesRequestState: HttpActionState.Failed,
        isDocumentTypesLoading: false,
        documentTypes: documentsTypeAdapter.getInitialState()
    })), 

    on(sharedStoreActions.saveUserTimeZoneSettingSuccess, (state, {userTimeZone}) => ({
        ...state,
        user_timezone: userTimeZone
    }))
)


/**
 * Update Chat Messages Through Pusher
 * @param messages 
 * @param newchat 
 * @returns 
 */
function updateMessages(messages:ActivityLogs[], newchat:ActivityLogs) {
    return messages?.some(x => x.id == newchat.id) ? messages : [...messages, newchat];
}


function updateActivitiesStatus(activities){
    return activities.map(item => {
        return {
            ...item,
            msg_status: { ...item.msg_status, status: 'seen' }
        };
    });
}
